

















































import { mapGetters } from 'vuex'
import client from '@/client/modules/common'
import { defineComponent, onUnmounted, reactive, computed, ref } from '@vue/composition-api'

import { useReflectiveInjector } from '@zhfe/vue2-di-plugin'
import { UserService } from '@/services/user.service'
import { CustomerService } from '@/services/customer.service'
import DeductionNoticeBtn from './_components/DeductionNoticeBtn.vue'
import { CUSTOMER_SERVICE_LINK, AB_LIST, UNFINISH_PAY_LIST } from '@/config/dataMap'
import { getCommentInfoAbTestRequest } from '@/api/user'
import UnfinishNotice from '@/components/activity/unfinishNotice/UnfinishNotice.vue'
import { getUnpaidGuideInfo } from '@/utils/sessionStorage'

export default defineComponent({
  name: 'Compheader',
  components: {
    DeductionNoticeBtn,
    UnfinishNotice
  },
  props: {
    white: Boolean,
    hideFeedback: Boolean,
    hideInvoice: Boolean,
    hideExchange: Boolean,
    draggableStyle: String,
    hideClose: Boolean,
    showDataReport: Boolean,
    showHaohuo: Boolean,
    showLianTong: Boolean,
    closeCallback: Function,
  },

  setup (props, context) {
    const injector = useReflectiveInjector()
    const user = injector.get(UserService)
    const customer = injector.get(CustomerService)

    const viewModel = reactive({
      isMember: user.isMember,
      isPdfMember: user.isPdfMember,
      isPdfLifeMember: user.isPdfLifeMember,
    })

    const isShowUnfinishNotice = ref(false) // 是否显示未支付完成引导

    const subUserInfoChanged = user.onUserInfoChanged.subscribe(() => {
      viewModel.isMember = user.isMember
      viewModel.isPdfMember = user.isPdfMember
      viewModel.isPdfLifeMember = user.isPdfLifeMember
    })

    const isVIP = computed(() => viewModel.isMember || viewModel.isPdfMember || viewModel.isPdfLifeMember)

    // 用户是否已登录
    const isLogin = computed(() => user.isUserLogin)

    onUnmounted(() => {
      subUserInfoChanged.unsubscribe()
    })

    /** 兑换会员 */
    function clickExchange () {
      context.emit('clickExchange')
    }

    async function close () {
      try {
        const hasCacheUnpaidGuide = getUnpaidGuideInfo()
        console.warn(' ===== hasCacheUnpaidGuide ===== ', hasCacheUnpaidGuide)
        // 扫过码但未支付的时候才弹窗
        if (hasCacheUnpaidGuide === UNFINISH_PAY_LIST.HAVE_SCAN_QRCODE && isLogin.value) {
          const abResult = await getCommentInfoAbTestRequest({ ab_name_list: AB_LIST.UNFINISH_PAY_AB_LIST })
          // @ts-ignore
          const strategyList = abResult.strategy_list
          // @ts-ignore
          if (abResult.resp_common.ret === 0 && strategyList.length > 0 && strategyList[0].payload.enable != undefined) {
            isShowUnfinishNotice.value = strategyList[0].payload.enable == 'true'
          }
        }
      } catch (e) {
        console.error(' === 未完成支付引导AB测请求失败 === ', e)
      }

      if (isShowUnfinishNotice.value) {
        return
      }

      handleClickClose()
    }

    // 触发真正的关闭
    function handleClickClose () {
      if (props.closeCallback) {
        props.closeCallback()
        return
      }
      context.emit('close')
      window.close()
      return false
    }

    function feedback () {
      if (isVIP.value) {
        window.open(CUSTOMER_SERVICE_LINK)
      } else {
        client.API.client_feedback()
      }
      context.emit('feedback')

      return false
    }

    function clickInvoicing () {
      context.emit('emitInvoicing')
    }

    // 未完成支付引导模块操作
    function handleCloseUnfinishNotice (status: number) {
      if (status === 1) {
        // 不关闭会员中心，只关闭未完成支付引导模块
        isShowUnfinishNotice.value = false
      } else {
        // 关闭会员中心，同时关闭未完成支付引导模块
        handleClickClose()
      }
    }

    return {
      clickExchange,
      close,
      clickInvoicing,
      feedback,
      isVIP,
      isLogin,
      isShowUnfinishNotice,
      handleCloseUnfinishNotice
    }
  },
})
